import Styles from './StatusPill.module.scss'
import { forwardRef, HTMLAttributes } from 'react'
import cx from 'classnames'
import { Icon } from '../../almanac-ui/icons/Types'
import { FocusProps } from '@react-aria/interactions'
import { filterDOMProps } from '@react-aria/utils'

export interface Props extends FocusProps, Omit<HTMLAttributes<HTMLSpanElement>, keyof FocusProps> {
  status: string | React.ReactNode
  frontIcon?: Icon
  size?: 'md' | 'sm'
}

export const StatusPill = forwardRef<HTMLSpanElement, Props>(
  ({ status, size = 'md', style, frontIcon: FrontIcon, className, ...rest }, fRef) => (
    <span
      ref={fRef}
      style={style}
      className={cx(
        Styles.pill,
        { [Styles.withFrontIcon]: Boolean(FrontIcon), [Styles.smallPill]: size === 'sm' },
        className,
      )}
      {...filterDOMProps(rest, { labelable: true, propNames: new Set(['title']) })}
    >
      {FrontIcon && <FrontIcon className={Styles.withFrontIcon} />}
      {status}
    </span>
  ),
)
